
import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'
const DEFAULT_ROW = 20
class PrintReportAnalysisBestJobcardBrand extends Component {

  constructor(...args){
    super(...args)

    this.state = ({
      data:{data:[],dataFormat:[]},
      report_title:'กำลังดึงข้อมูล..'
    })

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this.loadData()
  }

  loadData() {
    let {data} = this.state
    if (this.props.isRange==='false'&&this.props.year!==undefined&&this.props.month!==undefined&&this.props.day!==undefined) {
      ReportStore.loadReportAnalysisBestJobcardBrand(this.props.year, this.props.month, this.props.day, 0, '', (result) => {
        data.data = result.data
        data.dataFormat = this.getPagination(result.data)
        this.setState({data:data,report_title:'ไม่พบข้อมูล'})
      },()=>{
        this.setState({report_title:'เกิดข้อผิดพลาด'})
      })
    } else if (this.props.isRange==='true'&&this.props.startDate!==undefined&&this.props.endDate!==undefined) {
      ReportStore.loadReportAnalysisBestJobcardBrandRange(this.props.startDate,this.props.endDate,0,'',(result)=>{
        data.data = result.data
        data.dataFormat = this.getPagination(result.data)
        this.setState({data:data,report_title:'ไม่พบข้อมูล'})
      },()=>{
        this.setState({report_title:'เกิดข้อผิดพลาด'})
      })
    } else {
      this.setState({report_title:'ไม่พบข้อมูล'})
    }
  }

  getPagination(data) {
    let allData = []
    let newData = []
    let checkRow = -1
    
    data.forEach(function(item,index) {
      if (checkRow<DEFAULT_ROW) {
        newData.push(item)
        checkRow++
      }
      if (checkRow===DEFAULT_ROW-1||data.length-1===index) {
        allData.push(newData)
        newData = []
        checkRow = -1
      }
    })
    
    return allData
  }

  getNumberFormat(val) {
    if (val!==''&&val!==null&&val!==undefined&&!isNaN(val)) {
      return parseFloat(val).toLocaleString(undefined, {maximumFractionDigits: 2}) 
    }
    return val
  }

  getAmountPerRow(item) {
    let quantity = (item.quantity===''||item.quantity===null||item.quantity===undefined||isNaN(item.quantity)?0:item.quantity)
    let price_per_unit = (item.price_per_unit===''||item.price_per_unit===null||item.price_per_unit===undefined||isNaN(item.price_per_unit)?0:item.price_per_unit)
    let sum = 0
    sum = (quantity*price_per_unit)
    return sum
  }

  renderRowSummary() {
    let {data} = this.state
    let sum = 0
    data.data.forEach(function(item,index) {
      let amount = (item.amount===''||item.amount===null||item.amount===undefined||isNaN(item.amount)?0:item.amount)
      sum += (amount*1)
    })
    return(
      <tfoot>
        <tr>
          <th colSpan={8} className="text-right">ยอดรวมสุทธิ</th>
          <th className="text-right">{this.getNumberFormat(sum)}</th>
        </tr>
      </tfoot>  
    )
  }

  renderBrandImage(brand){
    return (<img alt='' src={"https://static.bigfix.co/img/car_brand/"+brand+"-32x32.png"}></img>)
  }

  renderRowData(data,_index) {
    return(
      data.map((item,index) => {
        return(
          <tr key={index}>
            <td className='text-center'>{index+1}</td>
            <td style={{fontSize:"12px"}}>{this.renderBrandImage(item.brand)} {item.brand}</td>
            <td className='text-center'>{item.brand_count}</td>
            <td className='text-right'>{this.getNumberFormat(item.part_price)}</td>
            <td className='text-right'>{this.getNumberFormat(item.wage_price)}</td>
            <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
            <td className='text-right'>{this.getNumberFormat(item.approve_part)}</td>
            <td className='text-right'>{this.getNumberFormat(item.approved_wage)}</td>
            <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
          </tr>
        )
      })
    )
  }

  renderTable(data,index,length) {
    return(
        <table className='table table-bordered table-print-report-sale-product'>
          <thead>
            <tr>
              <th rowSpan={2} className='text-center' style={{width:'50px'}}>ลำดับ</th>
              <th rowSpan={2} className='text-center' style={{width:'200px'}}>ยี่ห้อ</th>
              <th rowSpan={2} className='text-center' style={{width:'100px'}}>จำนวน <br /> รายการ</th>
              <th colSpan={3} className="text-center">เสนอราคา</th>
              <th colSpan={3} className="text-center">อนุมัติราคา</th>
            </tr>
            <tr>
              <th className='text-center' style={{width:'90px'}}>ค่าอะไหล่</th>
              <th className='text-center' style={{width:'90px'}}>ค่าแรง</th>
              <th className='text-center' style={{width:'90px'}}>มูลค่ารวม</th>
              <th className='text-center' style={{width:'90px'}}>ค่าอะไหล่</th>
              <th className='text-center' style={{width:'90px'}}>ค่าแรง</th>
              <th className='text-center' style={{width:'90px'}}>มูลค่ารวม</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData(data,index)}
          </tbody>
          {index===length?this.renderRowSummary():''}
        </table>
    )
  }

  renderComponentPage(data,index,length) {
    return(
          <div className='font-print statistics' key={index}>
            <header className="text-center">
              <h2>{this.props.title}</h2>
            </header>
            <div>
              {this.renderTable(data,index,length)}
            </div>
          </div>
    )
  }

  renderNoData() {
    return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
    )
  }

  render(){
    let {data} = this.state
    if (data.dataFormat.length===0) {
      return(
        <div>
          <PrintPreview
            size={'portrait'}
            leftBarTitle={this.props.title}
          >
            {this.renderNoData()}
          </PrintPreview>
        </div>
      )
    } else {
      return(
        <div>
          <PrintPreview
            size={'portrait'}
            leftBarTitle={this.props.title}
          >
            {
              data.dataFormat.map((item,index) => {
                return(
                  this.renderComponentPage(item,index,data.dataFormat.length-1)
                )
              })
            }
          </PrintPreview>
        </div>
      )
    }
  }
}

PrintReportAnalysisBestJobcardBrand.defaultProps = {
  title: 'ตารางรายงานสรุปซ่อมรถยี่ห้อยอดนิยม'
}

export default PrintReportAnalysisBestJobcardBrand;





// WEBPACK FOOTER //
// ./src/view/print/statistics/PrintReportAnalysisBestJobcardBrand.js